import { RequestMethods } from '../../constants';
import { api } from '../../';
import type {
  EntitlementsResponse,
  SubscriptionsResponse,
} from '~/redux/api/routes/subscriptions/models';
import type { PostVoidResponse } from '~/redux/api/models';
import { SubscriptionEndpoints } from '~/redux/api/routes/subscriptions/constants';

export const subscriptionsAPI = api.injectEndpoints({
  endpoints: (builder) => ({
    getEntitlements: builder.query<EntitlementsResponse, void>({
      query: () => ({
        url: SubscriptionEndpoints.getEntitlements,
        method: RequestMethods.GET,
      }),
    }),

    getSubscriptions: builder.query<SubscriptionsResponse, void>({
      query: () => ({
        url: SubscriptionEndpoints.getSubscription,
        method: RequestMethods.GET,
      }),
    }),

    cancelSubscription: builder.mutation<PostVoidResponse, string>({
      query: (subscriptionId) => ({
        url: `${SubscriptionEndpoints.cancelSubscription}/${subscriptionId}`,
        method: RequestMethods.DELETE,
      }),
    }),
  }),
});

export const {
  useCancelSubscriptionMutation,
  useLazyGetEntitlementsQuery,
  useGetSubscriptionsQuery,
} = subscriptionsAPI;
